export default __webpack_public_path__ + "static/code_bender-bf91ac9af75bf495189f6c241f12fc10.svg";